import { render, staticRenderFns } from "./GroupQuestion.vue?vue&type=template&id=985f673e&scoped=true"
import script from "./GroupQuestion.vue?vue&type=script&lang=js"
export * from "./GroupQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985f673e",
  null
  
)

export default component.exports